import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

export type GetNvalDetailIdResponse = {
  NvalDetailId: string,
}

/**
 * 1物N価詳細情報ID採番取得サービス
 *
 * @export GetNvalDetailIdService
 * @class GetNvalDetailIdService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetNvalDetailIdService extends PlessJsonResponderSub<GetNvalDetailIdResponse> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetNvalDetailIdService
   */
  private successFunc: Function = () => {};

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetNvalDetailIdService
   */
  execute(successFunc: Function = () => {}): void {
    this.successFunc = successFunc;
    this.send('getNvalDetailId', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetNvalDetailIdService
   */
  success(data: GetNvalDetailIdResponse): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
